import { Link } from 'react-router-dom';

const categoryList = [
  { name: '韩漫', icon: 'ri-kakao-talk-fill', desc: '韩国漫画精选', color: 'bg-primary-500' },
  { name: '日漫', icon: 'ri-sun-fill', desc: '日系漫画经典', color: 'bg-accent-500' },
  { name: '国漫', icon: 'ri-china-railway-fill', desc: '国产漫画崛起', color: 'bg-secondary-500' },
  { name: '热血', icon: 'ri-fire-fill', desc: '燃到爆的漫画', color: 'bg-primary-600' },
  { name: '恋爱', icon: 'ri-heart-3-fill', desc: '甜蜜恋爱故事', color: 'bg-accent-600' },
  { name: '奇幻', icon: 'ri-magic-fill', desc: '奇幻冒险世界', color: 'bg-secondary-600' },
];

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            漫画分类大全
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            按产地和类型快速筛选，精准找到心仪漫画
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categoryList.map((cat) => (
            <Link
              key={cat.name}
              to={cat.name === '韩漫' || cat.name === '日漫' || cat.name === '国漫' ? `/category/${cat.name}` : '/category/all'}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group flex flex-col items-center p-5 md:p-6 rounded-xl bg-background-50 hover:bg-background-50 transition-colors cursor-pointer"
            >
              <div
                className={`w-12 h-12 md:w-14 md:h-14 rounded-full ${cat.color} flex items-center justify-center mb-3 transition-transform duration-300 group-hover:scale-110`}
              >
                <i className={`${cat.icon} text-background-50 text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-950">{cat.name}</h3>
              <p className="text-[11px] md:text-xs text-foreground-500 mt-1">{cat.desc}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}